import React, { useEffect, useState } from "react";
import { Navbar, Nav, Container, Dropdown } from "react-bootstrap";
import { Cart4 } from "react-bootstrap-icons";
import { PUBLIC_URL } from "../serviceWorker";
import { useDispatch, useSelector } from "react-redux";
import { fetchCart, resetClient } from "../actions/cartActions";
import { fetchShop, fetchMenu, setLogin } from "../actions/shopActions";
import { RootState } from "../reducers";
import AlertOutStock from "./AlertOutStock";
import SearchProducts from "./SearchProducts";
import MegaMenuProducts from "./MegaMenuProducts";
import { useNavigate } from "react-router-dom";
import useTenant from "../tenant/useTenant";
import { buildAssetPath } from "../tenant/tenantConfig";

const Navigation = () => {
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
  const [showProductsDropdown, setShowProductsDropdown] = useState(false);
  const itemsCart = useSelector((state: RootState) => state.cart.itemsCart);
  const tenant = useTenant();

  const menuProducts = useSelector(
    (state: RootState) => state.shop.menuProducts,
  );
  const isLogued = useSelector((state: RootState) => state.shop.isLogued);
  const textPages = useSelector((state: RootState) => state.shop.textPages);
  const dispatch: any = useDispatch();
  const style = {
    color: "#212529",
    fontSize: "1.2rem",
    textDecoration: "none",
  };
  const navigate: any = useNavigate();
  const cellPhoneStorage = localStorage.getItem("cell_phone");
  const clientIdStorage = localStorage.getItem("client_id");

  useEffect(() => {
    dispatch(fetchCart());
    dispatch(fetchShop());
    dispatch(fetchMenu());
    const container = document.getElementById("container");
    if (container)
      container.addEventListener("click", () => {
        setDropdownIsOpen(false);
      });
  }, [dispatch]);

  useEffect(() => {
    if (cellPhoneStorage && clientIdStorage) {
      dispatch(setLogin({ isLogued: true }));
    }
  }, [cellPhoneStorage, clientIdStorage, dispatch, isLogued]);

  const onLogout = () => {
    dispatch(resetClient());
    dispatch(setLogin({ isLogued: false }));
  };

  return (
    <Navbar
      expand="lg"
      variant="light"
      className="mb-3 justify-content-between"
      expanded={dropdownIsOpen}
      onToggle={() => setDropdownIsOpen(!dropdownIsOpen)}
      style={{
        backgroundColor: tenant.primaryColor,
        color: tenant.primaryTextColor,
      }}
    >
      <Container fluid>
        <Navbar.Brand
          onClick={() => {
            navigate("/");
            setDropdownIsOpen(false);
          }}
        >
          <img
            alt={tenant.brandName}
            src={PUBLIC_URL + buildAssetPath(tenant.shopId, tenant.logoFile)}
            height="45"
          />
        </Navbar.Brand>
        {itemsCart > 0 && (
          <Nav.Link
            onClick={() => {
              navigate("/cart");
              setDropdownIsOpen(false);
            }}
            className="p-0 me-2"
            style={style}
          >
            <Cart4 className="me-1" size={25} />
            {itemsCart}
          </Nav.Link>
        )}
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <div className="d-lg-none w-100 mt-3 mb-1">
          <SearchProducts />
        </div>
        <Navbar.Collapse id="responsive-navbar-nav">
          <div className="d-none d-lg-block">
            <SearchProducts />
          </div>
          <Nav.Link
            className="px-3 py-2"
            onClick={() => {
              navigate("/");
              setDropdownIsOpen(false);
            }}
            style={style}
          >
            Inicio
          </Nav.Link>
          <Dropdown
            show={showProductsDropdown}
            onToggle={(isOpen) => setShowProductsDropdown(isOpen)}
          >
            <Dropdown.Toggle
              style={style}
              variant="link"
              id="dropdown-products"
              className="px-3 py-2 text-decoration-none"
            >
              Productos
            </Dropdown.Toggle>
            <Dropdown.Menu className="border-0 shadow">
              {menuProducts?.length > 0 && (
                <MegaMenuProducts
                  menuProducts={menuProducts}
                  setDropdownIsOpen={setDropdownIsOpen}
                  closeMenu={() => setShowProductsDropdown(false)}
                  style={style}
                />
              )}
            </Dropdown.Menu>
          </Dropdown>
          {tenant.features.hasMyOrders && (
            <Nav.Link
              className="px-3 py-2"
              onClick={() => {
                navigate("/my-orders");
                setDropdownIsOpen(false);
              }}
              style={style}
            >
              Mis pedidos
            </Nav.Link>
          )}

          {textPages &&
            (textPages.textHowtobuy ||
              textPages.textHowtopay ||
              textPages.textSends ||
              textPages.textChanges) && (
              <Dropdown>
                <Dropdown.Toggle
                  style={style}
                  variant="link"
                  id="dropdown-basic"
                  className="px-3 py-2 text-decoration-none"
                >
                  Como comprar
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {textPages.textHowtobuy && (
                    <Dropdown.Item
                      style={style}
                      onClick={() => {
                        navigate("/howtobuy");
                        setDropdownIsOpen(false);
                      }}
                    >
                      Pasos a seguir
                    </Dropdown.Item>
                  )}
                  {textPages.textHowtopay && (
                    <Dropdown.Item
                      style={style}
                      onClick={() => {
                        navigate("/howtopay");
                        setDropdownIsOpen(false);
                      }}
                    >
                      Formas de pago
                    </Dropdown.Item>
                  )}
                  {textPages.textSends && (
                    <Dropdown.Item
                      style={style}
                      onClick={() => {
                        navigate("/sends");
                        setDropdownIsOpen(false);
                      }}
                    >
                      Envío
                    </Dropdown.Item>
                  )}
                  {textPages.textChanges && (
                    <Dropdown.Item
                      style={style}
                      onClick={() => {
                        navigate("/changes");
                        setDropdownIsOpen(false);
                      }}
                    >
                      Política de cambios
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            )}
          <Nav.Link
            className="px-3 py-2"
            onClick={() => {
              navigate("/contact");
              setDropdownIsOpen(false);
            }}
            style={style}
          >
            Contacto
          </Nav.Link>
          {isLogued && (
            <Nav.Link
              className="px-3 py-2"
              onClick={() => {
                navigate("/");
                setDropdownIsOpen(false);
                onLogout();
              }}
              style={style}
            >
              Salir
            </Nav.Link>
          )}
        </Navbar.Collapse>
      </Container>
      <AlertOutStock />
    </Navbar>
  );
};

export default Navigation;
